export default __webpack_public_path__ + "media/images/elephant_ui_working-7d46594fc168e1430dad2939f4ed899a.svg";